import React from 'react';

import Button from '@material-ui/core/Button';


class Comp extends React.Component {

  render() {
    let backgroundColor;
    let textColor;
    let borderColor;

    if (this.props.disabled) {
      borderColor = '#DDD';
      backgroundColor = '#FFF';
      textColor = '#AAA';
    }
    else if (this.props.checked) {
      borderColor = '#CD4695';
      backgroundColor = '#E7B0D0';
      textColor = '#5D0036';
    }
    else {
      borderColor = '#BBB';
      backgroundColor = '#FFF';
      textColor = '#333';
    }

  	return (
      <Button
        size="small"
        variant="outlined"
        onClick={ () => this.props.click(this.props.value) }
        style={{
          color: textColor,
          backgroundColor: backgroundColor,
          borderType: 'solid',
          borderWidth: '1px',
          borderColor: borderColor,
          margin: '3px',
          fontSize: '1.2em',
          textAlign: 'left',
        }}
        disabled={this.props.disabled}
      >
        {this.props.children}
  		</Button>
  	)
  }
}

export default Comp;
